import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DefaultService } from 'src/app/core/framework/default-service';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { IPacientePorRotaDTO } from '../../mapa/popover-assistente-de-criacao-de-rota/model/paciente-por-rota-dto.interface';
import { GeocodeResult } from './model/google-maps-geocode-result.interface';
import { GeocodeReversoResult } from './model/google-maps-geocode-reverso-result.interface';


@Injectable({
  providedIn: 'root'
})
export class GisService extends DefaultService<any> {

  static URL = '/api/endereco/gis/v1/gis';

  constructor(
    public httpClient: HttpClient,
    public errorHandlerService: ErrorHandlerService
  ) {
    super(httpClient, errorHandlerService, GisService.URL);
  }

  geocode(endereco: string, uf: string): Observable<GeocodeResult> {
    return this.httpClient.get<GeocodeResult>(`${GisService.URL}/geocode?endereco=${endereco}&uf=${uf}`)
                          .pipe(
                            catchError( err => throwError(this.errorHandlerService.handle(err)) )
                          );
  }


  geocodeReverso(latitude: number|string, longitude: number|string): Observable<GeocodeReversoResult> {
    return this.httpClient.get<GeocodeReversoResult>(`${GisService.URL}/geocodeReverso?latitude=${latitude}&longitude=${longitude}`)
                          .pipe(
                            catchError(err => throwError(err))
                          );
  }

  ordenarRotaDePacientesPorLocalizacao(idRota: number, itens: IPacientePorRotaDTO[]): Observable<IPacientePorRotaDTO[]> {
    return this.httpClient.post<IPacientePorRotaDTO[]>(`${GisService.URL}/ordenarRotaDePacientesPorLocalizacao?idRota=${idRota}`, itens)
                          .pipe(
                            catchError(err => throwError(err))
                          );
  }
}
